import { Layout } from "./components/layout";
import { Comments } from "./components/comments";
import { Redirect, Route, Switch } from "react-router-dom";

export const App = () => {
  return (
    <Layout>
      <Switch>
        <Route path="/oidc/signin-callback">
          <Redirect to="/" />
        </Route>
        <Route path="/">
          <Comments />
        </Route>
      </Switch>
    </Layout>
  );
};
